import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import { equals, propEq } from "ramda";
import ViewButtonFieldset from "@interdependence-ui/viewButtonFieldset/ViewButtonFieldset";
import { allGraphTypes } from "utils/graphs";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var GraphSelector = /*#__PURE__*/memo(function (props) {
  var id = props.id,
    className = props.className,
    selected = props.selected,
    availableGraphs = props.availableGraphs,
    name = props.name,
    onChange = props.onChange;
  var graphOptions = availableGraphs.map(function (id) {
    var option = allGraphTypes.find(propEq("id", id));
    return _objectSpread(_objectSpread({}, option), {}, {
      checked: selected === option.id,
      icon: "".concat(option.icon, "_md")
    });
  });
  return /*#__PURE__*/_jsx(ViewButtonFieldset, _objectSpread({
    id: "graph-select-fieldset-".concat(id),
    className: className,
    legend: "V\xE4lj diagramtyp",
    name: name,
    options: graphOptions,
    updateSelected: onChange
  }, extendedSystemStylesProps(styledSystemKeys, props)));
}, function (prev, curr) {
  return equals(prev.selected, curr.selected);
});
GraphSelector.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  availableGraphs: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default GraphSelector;